import { render, staticRenderFns } from "./videoStepLayer.vue?vue&type=template&id=b0befaf8&"
import script from "./videoStepLayer.vue?vue&type=script&lang=js&"
export * from "./videoStepLayer.vue?vue&type=script&lang=js&"
import style0 from "./videoStepLayer.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports